import { parse } from "date-fns";
import TimePicker from "../../shared/form/fields/TimePicker";
import formatDate from "../../../helpers/formatDate";
import { Controller, ControllerProps, useFormContext } from "react-hook-form";
import { isEmpty } from "lodash";
import classNames from "classnames";

type ScheduleTimeFieldArgs = {
  name: string;
  dateName: string;
  allowEmpty?: boolean;
  rules?: ControllerProps["rules"];
  disabled?: boolean;
};

export default function ScheduleTimeField({
  name,
  dateName,
  allowEmpty = false,
  rules,
  disabled = false,
}: ScheduleTimeFieldArgs) {
  const { control, watch } = useFormContext();
  const date = watch(dateName);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        const time = !isEmpty(field.value)
          ? parse(
              field.value,
              "HH:mm",
              date ? new Date(date) : new Date(),
            ).toISOString()
          : undefined;

        return (
          <TimePicker
            name={field.name}
            value={time}
            onChange={(value) =>
              field.onChange(
                !isEmpty(value)
                  ? formatDate(new Date(value), "HH:mm")
                  : undefined,
              )
            }
            allowEmpty={allowEmpty}
            disabled={disabled}
            groupClassName={classNames({
              "field-error field-error-live": !!fieldState.error,
            })}
          />
        );
      }}
    />
  );
}
